































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Getter } from 'vuex-class';
import { AdminRoleList } from '@/configs/role';
import {
  getProgressList, deleteProgress, postActiveStatus, postSendSms,
} from '@/configs/api-path';
import CheckProjectMixin from '@/mixins/check-project';
import VuetableMixin from '@/mixins/vuetable';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import ProgressSmsAlertMixin from '@/mixins/progress-sms';
import DatatableHeading from '@/components/piaf/Datatable/DatatableHeading.vue';
import VuetablePaginationBootstrap from '@/components/piaf/Common/VuetablePaginationBootstrap.vue';
import { VuetableSortOrder, VuetablePagination } from '@/@types/vuetable.d';
import { roleIsHigherThen } from '@/utils/role';
import { ProjectMenu, AttachProject } from '@/models/project';
import { ProgressListItem } from '@/models/progress';
import { UserLogin } from '@/models/user';

const extendSmsErrorMessage = {
  110: '簡訊帳號餘額不足，無法使用簡訊發送服務，請至三竹簡訊購買儲值點數',
  111: '沒有簡訊需要發送',
  4: '簡訊發送失敗，進度狀態未啟用或是簡訊內容未填寫',
};

@Component({
  components: {
    DatatableHeading,
    VuetablePaginationBootstrap,
  },
})
export default class PageProgressList extends mixins(
  CheckProjectMixin, VuetableMixin, ApiStatusMixin, ApiErrorMixin, ProgressSmsAlertMixin,
) {
  tablePrepage = 10;

  currentProject: AttachProject | null = null;

  project: ProjectMenu | null = null;

  progressList: ProgressListItem[] = [];

  dataTableFields = [
    {
      name: 'title',
      title: '工程項目',
      sortField: 'title',
    },
    {
      name: 'updated_at',
      title: '更新日期',
      sortField: 'updated_at',
    },
    {
      name: 'publish_time',
      title: '發佈日期',
      sortField: 'publish_time',
    },
    {
      name: 'sms-status--slot',
      title: '簡訊發送狀態',
      width: '140px',
      sortField: 'is_send',
    },
    {
      name: 'sms-count--slot',
      title: '住戶數 / 已發送 / 未發送',
      width: '190px',
    },
    // {
    //   name: 'status--slot',
    //   title: '狀態',
    //   width: '140px',
    //   sortField: this.sortMode ? null : 'status',
    // },
    {
      name: 'status--slot',
      title: '狀態',
      width: '110px',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: 'action--slot',
      title: '操作',
      // width: '300px',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
  ];

  get projectId() {
    return this.$route.params.projectId;
  }

  get filtedProgressList() {
    return this.progressList
      .filter((progress) => {
        const matchRegexp = new RegExp(this.filterKeyword === '' ? '.*' : `.*(${this.filterKeyword}).*`, 'gi');

        const matchProgressTitle = progress.title === '' ? true : progress.title.match(matchRegexp);

        return Boolean(matchProgressTitle);
      });
  }

  get breadcrumb() {
    return [
      {
        text: '進度管理',
        to: null,
      },
      {
        text: this.currentProject?.name,
        to: null,
      },
    ];
  }

  @Getter('app/getMenuProjectsAll') getProjectMenu!: ProjectMenu[];

  @Getter('user/currentUser') currentUser!: UserLogin;

  @Watch('filtedProgressList')
  onFiltedProgressListChange() {
    this.$refs.vuetable.refresh();
  }

  @Watch('tablePrepage')
  onTablePrepageChange() {
    if (this.vuetablePrepage !== undefined) {
      this.vuetablePrepage = this.tablePrepage;
    }
    this.$refs.vuetable.refresh();
  }

  testRoleIsHigher(roleCode: number) {
    return roleIsHigherThen((this.currentUser.role as AdminRoleList).code, roleCode, true);
  }

  changePageSize(size: number) {
    this.tablePrepage = size;
  }

  onChangePage(page: number) {
    this.$refs.vuetable.changePage(page);
  }

  dataManager(sortOrder: VuetableSortOrder[], pagination: VuetablePagination) {
    const tableData = this.vuetableDataManager(
      sortOrder,
      pagination,
      this.$refs.vuetable,
      this.filtedProgressList,
    );
    this.tablePagination = tableData.pagination;
    return tableData;
  }

  onPaginationData(paginationData: VuetablePagination) {
    this.$refs.pagination.setPaginationData(paginationData);
  }

  async sendSms(progressId: number) {
    if (!progressId) {
      return;
    }

    try {
      const sendData: {
        progressId: number;
      } = {
        progressId,
      };

      const { data: smsResponse } = await this.$axios.post<{
        code: number;
      }>(postSendSms, sendData);

      if (smsResponse.code === 0) {
        this.fetchProgressList();
        this.smsAlertAfterSent();
      } else {
        this.apiErrorCodeAlert(smsResponse.code, '建案進度管理', extendSmsErrorMessage);
      }
    } catch (err) {
      console.error(err);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  sendGroupSms(check: boolean, progressId: number) {
    if (check === true) {
      this.sendSms(progressId);
    }
  }

  cancelSendSms() {
    this.$notify.show('info filled', '簡訊未發送', '建案進度管理');
  }

  async fetchProgressList() {
    if (!this.projectId) {
      this.$notify.show('error filled', '查無此建案', '住戶管理');
      return;
    }

    this.setApiLoading();
    try {
      const { data: progressListResponse } = await this.$axios.get<{
        code: number;
        progress: ProgressListItem[];
      }>(getProgressList(this.projectId));

      console.log(progressListResponse);

      if (progressListResponse.code === 0) {
        this.progressList = progressListResponse.progress;
      } else {
        this.apiErrorCodeAlert(progressListResponse.code, `${this.currentProject?.name}進度管理`);
      }
    } catch (error) {
      console.error(error);
      this.apiHttpErrorAlert(error.response, `${this.currentProject?.name}進度管理`);
    }
    this.setApiPending();
  }

  async toggleProgressStatus(nextStatus: boolean, progress: ProgressListItem) {
    if (!progress.id) {
      return;
    }

    this.setApiLoading();
    try {
      const statusData = {
        module: 5,
        targetId: progress.id,
        status: nextStatus,
      };

      const { data: statusResponse } = await this.$axios.post<{
        code: number;
      }>(postActiveStatus, statusData);

      if (statusResponse.code === 0) {
        this.$notify.show('success filled', `<b>${progress.title}</b> 已${nextStatus === true ? '啟用' : '停用'}！`, `${nextStatus === true ? '啟用' : '停用'}${this.currentProject?.name}進度`, { duration: 3000, permanent: false });
      } else {
        const progressInList = this.progressList.find((oProgress) => oProgress.id === progress.id);
        if (progressInList) {
          progressInList.status = !nextStatus;
        }
        this.apiErrorCodeAlert(statusResponse.code, `${nextStatus === true ? '啟用' : '停用'}${this.currentProject?.name}進度`);
      }
    } catch (error) {
      this.apiHttpErrorAlert(error.response, `${nextStatus === true ? '啟用' : '停用'}${this.currentProject?.name}進度`);
      console.error(error);
    }
    this.setApiPending();
  }

  async deleteProgress(progress: ProgressListItem) {
    if (!progress.id) {
      return;
    }

    if (!this.currentProject) {
      return;
    }

    const progressId = progress.id as number;
    // eslint-disable-next-line no-alert
    const confirm = window.confirm(`確定刪除「${progress.title}」？\n刪除後將無法復原該進度。`);

    if (confirm === false) {
      return;
    }

    this.setApiLoading();
    try {
      const { data: deleteResponse } = await this.$axios.delete<{
        code: number;
        progress: {
          id: number;
        };
      }>(deleteProgress(progressId));

      if (deleteResponse.code === 0) {
        this.$notify.show('success filled', `「${progress.title}」已刪除！`, `刪除${this.currentProject.name}進度`, { duration: 3000, permanent: false });

        const itemIndexInList = this.progressList
          .findIndex((oProgress) => oProgress.id === progressId);

        this.progressList.splice(itemIndexInList, 1);
      } else {
        this.apiErrorCodeAlert(deleteResponse.code, `刪除${this.currentProject.name}進度`, {
          107: '刪除失敗，已發送過簡訊的進度無法刪除',
        });
      }
    } catch (error) {
      this.apiHttpErrorAlert(error.response, `刪除${this.currentProject.name}進度`);
      console.error(error);
    }
    this.setApiPending();
  }

  async checkProjectAndFetch() {
    try {
      this.setApiLoading();
      const projectExist = await this.checkProjectExistII(this.projectId);
      this.setApiPending();

      if (projectExist.code === 0) {
        this.currentProject = {
          id: projectExist.project.id,
          name: projectExist.project.name,
        };

        this.fetchProgressList();
      } else {
        this.$notify.show('error filled', projectExist.message, '進度管理');
      }
    } catch (error) {
      this.$notify.show('error filled', error.message, '進度管理');
      console.error(error.message);
    }
  }

  beforeMount() {
    this.checkProjectAndFetch();
  }
}
